/**
 * footer.js — نغمة ستور
 * تحسين وصول (Accessibility) بسيط فقط لنموذج النشرة البريدية الحقيقي في
 * الفوتر (Shopify customer form). لا منطق إرسال هنا إطلاقًا — النموذج
 * يعمل بالكامل بدون جافاسكريبت (POST عادي)، وأعمدة الروابط تُطوى/تُفتح
 * عبر <details>/<summary> الأصلية بلا أي سكربت (انظر component-footer.css).
 *
 * الوظيفة الوحيدة هنا: بعد إعادة تحميل الصفحة عقب إرسال النموذج (نجاحًا
 * أو خطأً)، تُنقل بؤرة التركيز (focus) إلى رسالة النتيجة مباشرة، حتى
 * يُعلنها قارئ الشاشة فورًا للمستخدمين الذين لا تصل نظرتهم تلقائيًا إلى
 * الفوتر أسفل الصفحة بعد إعادة التحميل.
 */
(function () {
  "use strict";

  function focusNewsletterMessage(root) {
    var message = root.querySelector("[data-newsletter-message]");
    if (!message || message.dataset.newsletterFocused === "true") return;
    message.dataset.newsletterFocused = "true";
    message.focus();
  }

  function initFooter(root) {
    if (!root) return;
    focusNewsletterMessage(root);
  }

  window.Naghmah = window.Naghmah || {};
  var Naghmah = window.Naghmah;

  if (Naghmah.registerSection) {
    Naghmah.registerSection("footer", initFooter);
  }

  Naghmah.onReady(function () {
    var footer = document.querySelector('[data-section-type="footer"]');
    if (footer) initFooter(footer);
  });
})();
